import React from "react";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { CustomButton } from "../../../../v2/MUI_custom_component";
import { toCapitalized } from "../../../../v2/Utils/Capitalize";
import { addressToLine } from "../../utils/addressMapper";

dayjs.extend(customParseFormat);

const formatDob = (dob) => {
  if (!dob) return "-";
  const d = dayjs(dob, ["YYYY-MM-DD", "DD-MM-YYYY"]);
  return d.isValid() ? d.format("DD MMMM YYYY") : "-";
};

const Row = ({ label, value }) => (
  <Box
    sx={{
      display: "flex",
      gap: 1,
      alignItems: "flex-start",
      py: 1,
      width: "100%",
    }}>
    <Typography
      sx={{
        width: 160,
        flexShrink: 0,
        fontSize: 16,
        lineHeight: "24px",
        color: "#666666",
      }}>
      {label}
    </Typography>
    <Typography
      sx={{ flex: "1 1 0", fontSize: 16, lineHeight: "24px", color: "#333333" }}>
      {value || "-"}
    </Typography>
  </Box>
);


const Section = ({ title, rows, sx }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 2, ...sx }}>
    <Typography
      sx={{ fontSize: 20, lineHeight: "32px", fontWeight: 600, color: "#333333" }}>
      {title}
    </Typography>
    <Box
      sx={{
        bgcolor: "#FFFFFF",
        borderRadius: "16px",
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 1,
        width: "100%",
        flex: 1,
      }}>
      {rows.map((r) => (
        <Row key={r.label} label={r.label} value={r.value} />
      ))}
    </Box>
  </Box>
);


const UserDetailsPreview = ({ data = {}, onOnboard, onCancel, submitting = false }) => {
  const name = [data.firstname, data.lastname].filter(Boolean).join(" ");
  const isVcp = !!(data.company_gstin || data.company_name);
  const address = toCapitalized(addressToLine(data.operational_address));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 2, md: 4 },
        width: "100%",
      }}>
      <Box
        sx={{
          width: { xs: "100%", md: isVcp ? "70vw" : 616 },
          maxWidth: "100%",
        }}>
        {isVcp ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: 2,
              width: "100%",
            }}>
            <Section
              title="User Details"
              sx={{ flex: { md: "0 0 40%" } }}
              rows={[
                {
                  label: "Buyer Role",
                  value: data.role ? toCapitalized(data.role) : "-",
                },
                { label: "Name", value: name },
                { label: "Mobile Number", value: data.phone_number },
              ]}
            />
            <Section
              title="Business Information"
              sx={{ flex: "1 1 0" }}
              rows={[
                { label: "GST", value: data.company_gstin || "-" },
                { label: "PAN", value: data.pancard_no || "-" },
                { label: "Address", value: address },
              ]}
            />
          </Box>
        ) : (
          <Section
            title="User Details"
            rows={[
              {
                label: "Buyer Role",
                value: data.role ? toCapitalized(data.role) : "-",
              },
              { label: "Name", value: toCapitalized(name) },
              { label: "Date of Birth", value: formatDob(data.dob) },
              {
                label: "Gender",
                value: data.gender ? toCapitalized(data.gender) : "-",
              },
              { label: "Mobile Number", value: data.phone_number },
              { label: "Address", value: address },
            ]}
          />
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.5,
          width: "616px",
          maxWidth: "100%",
        }}>
        <CustomButton
          label="Onboard"
          fullWidth
          loading={submitting}
          onClick={onOnboard}
        />
        <CustomButton
          label="Cancel"
          variant="text"
          fullWidth
          onClick={onCancel}
        />
      </Box>
    </Box>
  );
};

export default UserDetailsPreview;
